export default __webpack_public_path__ + "static/fivestars-034758b91dfd5d878c50c850b5945a9b.png";